import React from 'react';
import './RotatingDisc.css';

function RotatingDisc({ label = '2026 Edition', detail = 'Industrial scale' }) {
  return (
    <div className="rotating-disc" aria-hidden="true">
      <div className="disc-rings">
        <span className="orbit-dot" />
        <span className="orbit-dot orbit-dot-two" />
      </div>
      <div className="disc-copy">
        <small>{label}</small>
        <strong>{detail}</strong>
      </div>
    </div>
  );
}

export default RotatingDisc;
